import {_authorizationHeaders, Api} from './config/request';
import {storage} from './config/storage';
import qs from 'qs';

const searchEntity = (p) => {
    let paramObject = {...p};
    paramObject.searchDescription = p.searchDesc;
    delete paramObject.searchDesc;
    return Api.postRequest('searchEntity', paramObject);
};

const watchList = (p) => {
    let dto = p;
    return Api.postRequest('updateUserPortDetails', dto);
};

const updateUserProps = (payload, params = '') =>
    Api.postRequest(`setUserProps?${params}`, payload);

const getFieldList = (group = '') =>
    Api.getRequest(`getFieldList?group=${group}`, {resType: 'json'});
const updateUser = (p) => Api.postRequest(`editUser`, p);

export const getNewsContent = (p) => Api.postRequest('getNewsContent', p);

export const checkUserAccess = (payload) =>
    Api.postRequest('checkEntityAccess', payload);

const getNotification = (p) =>
    Api.getListRequest(`getNotification?${qs.stringify(p)}`);
const forgotPassword = (p) => Api.postRequest('forgotPassword', p);

const changeTempPassword = (p) => Api.postRequest('changeTempPassword', p);
const changePassword = (p) => Api.postRequest('changePassword', p);
const getLanding = () => Api.getListRequest(`getUiLandingPage`);
const getMacro = () => Api.getRequest('getUiMacroPage', {resType: 'json'});
const saveImages = (query, p) =>
    Api.postRequest(`saveS3Files?images=${query}`, p);
const getS3Files = (p, options) =>
    Api.getRequest(
        `getS3Files?fileType=${p.fileType}&fileGroup=${p.fileGroup}&fileId=${p.fileId}`,
        {resType: 'json', ...options},
    );

const getfinancialExcelDownload = (p) =>
    Api.getRequest(`getfinancialExcelDownload?entityId=${p.companyId}`, {
        resType: 'json',
    });
const getBBModel = (p) =>
    Api.getRequest(`getBBModel?companyId=${p}`, {
        resType: 'json',
    });

const saveS3Files = (file, p) =>
    Api.postRequestDirect(
        `saveS3Files?fileName=${file.fileName}&fileType=${file.fileType}&fileGroup=${file.fileGroup}&info=${file.info}`,
        p,
        {
            ..._authorizationHeaders(),
            'Content-Type': 'multipart/form-data',
        },
    );

const listS3Files = (p) =>
    Api.getRequest(
        `listS3Files?fileType=${p.fileType}&fileGroup=${p.fileGroup}${
            p.entityId ? `&entityId=${p.entityId}` : ''
        }`,
        {resType: 'json'},
    );

const sendFeedBack = (feedback) => Api.postRequest('saveFeedback', feedback);

const logUiEvents = (p) => Api.postRequest('logUiEvents', p);
const getGlobalProps = (p) =>
    Api.getRequest(`getGlobalProps?key=${p}`, {resType: 'json'});
const setGlobalProps = (payload) => {
    return Api.postRequest(
        `setGlobalProps?key=${payload.key}&allowedRoleWithPass=${payload.allowedRoleWithPass}&allowedRolesWithoutPassword=${payload.allowedRolesWithoutPassword}&value=${payload.value}`,
    );
};
const getEntityUrl = (query) =>
    Api.getRequest(`getEntityUrl?${query}`, {resType: 'json'});
const getPortfolioUrl = (p) =>
    Api.getRequest(`getPortUrl?portSecId=${p.secId}&portId=${p.id}`, {
        resType: 'json',
    });
const getPortfolioUrlWithoutSection = (id) =>
    Api.getRequest(`getPortUrl?portId=${id}`, {
        resType: 'json',
    });

const getEntityPortfolio = (params = '', options) =>
    Api.getRequest(`getPortList?${params}`, {
        resType: 'json',
        ...options,
    });

const getPortList = (payload) => {
    payload.nonEntitySearch = storage.fetch.userDetails().nonEntitySearch;
    payload.entitySearch = storage.fetch.userDetails().entitySearch;
    const response = Api.postRequest('getPortList', payload);
    return response;
};

const getEntityPortFilter = (params = '', options) =>
    Api.getRequest(`getPortFilter?${params}`, {
        resType: 'json',
        ...options,
    });

const getUserPortfolio = () =>
    Api.getRequest('getUserPortList', {resType: 'json'});

const getEntityName = (p) =>
    Api.getRequest(`getEntityName?entityId=${p.ids}&entityType=${p.type}`, {
        resType: 'json',
    });

const getEntityPDF = (p) =>
    Api.getRequest(
        `getEntityPdf?entityId=${p?.id}&entityType=Company&type=${p?.type}`,
        {
            resType: 'json',
        },
    );

const getEntitySignal = (p) => {
    p.entityId = [p.entityId];
    if (p.entityType === 'Industry' || p.entityType === 'Country') {
        p.entityType += 'Template';
    }
    return Api.postRequest(`getSignalData`, p);
};

const getEntitySignalCount = (p) => {
    p.entityId = [p.entityId];
    if (p.entityType === 'Industry' || p.entityType === 'Country') {
        p.entityType += 'Template';
    }
    return Api.postRequest(`getSignalDataCount`, p);
};

const getEntityChartMetadata = (p) =>
    Api.getRequest(`getEntityChartMetadata?${p}`, {resType: 'json'});

const getPortfolioDetails = (p) =>
    Api.getRequest(`getPortDetails?portId=${p}`, {resType: 'json'});
const getPortfolioDetailsByGroup = (p) =>
    Api.getRequest(`getPortDetails?groupId=${p}`, {resType: 'json'});

const getUserList = (params = '') =>
    Api.getRequest(`getUserList?${params}`, {resType: 'json'});
const getLeadAnalystList = (params = {}, options) => {
    // Api.getRequest(`getLeadAnalystList?${params}`, {
    //     resType: 'json',
    //     ...options,
    // });
    let input = {
        resType: 'json',
        ...options,
    };
    return Api.postRequest(`getLeadAnalystList`, params, input, {
        renewToken: false,
    });
};
const getAnalystCoverage = (params = '', options) => {
    //    return Api.getRequest(`getLeadAnalystCoverage?${params}`, {
    //         resType: 'json',
    //         ...options,
    //     });

    const userIds = {
        resType: 'json',
        ...options,
    };

    return Api.getRequest(`getLeadAnalystCoverage?${params}`, userIds);
};

const getShortlistedList = (query) =>
    Api.getRequest(`getShortlistedEntityInfo?${query}`, {resType: 'json'});
const getShortlistingEntityInfo = (p) => {
    return Api.postRequest(`getShortlistingEntityInfo`, p);
};

const unsubscribeEmail = (p) => Api.postRequest('unsubNotification', p);

// These apis require bypass or renew token options
const loginUser = (p) => Api.postRequest('user/verify', p, {renewToken: true});
const getUserDetails = () => Api.getRequest(`user/details`, {resType: 'json'});

export const loginFreeUser = () =>
    Api.postRequest('loginFreeUser', {}, {renewToken: true});

export const logout = () =>
    Api.postRequest(`logOffUser`, {}, {bypassToken: true});

//self registration
export const upgradeAccount = (profile, rmEmail, company) => {
    return Api.getRequest(
        `upgradeAccount?profile=${profile}&rmEmail=${rmEmail}&company=${company}`,
        {resType: 'json'},
    );
};

const GlobalApi = {
    searchEntity,
    watchList,
    loginUser,
    getNewsContent,
    getNotification,
    forgotPassword,
    changeTempPassword,
    changePassword,
    updateUserProps,
    updateUser,
    getLanding,
    saveImages,
    getS3Files,
    getfinancialExcelDownload,
    saveS3Files,
    listS3Files,
    sendFeedBack,
    logUiEvents,
    loginFreeUser,
    getGlobalProps,
    setGlobalProps,
    getEntityUrl,
    getPortfolioUrl,
    getUserPortfolio,
    getEntityName,
    getEntitySignal,
    getEntitySignalCount,
    getEntityChartMetadata,
    getEntityPortfolio,
    getPortfolioDetails,
    getShortlistedList,
    checkUserAccess,
    unsubscribeEmail,
    getUserList,
    getLeadAnalystList,
    getAnalystCoverage,
    getFieldList,
    getEntityPortFilter,
    getShortlistingEntityInfo,
    getPortfolioDetailsByGroup,
    logout,
    getPortfolioUrlWithoutSection,
    getBBModel,
    getMacro,
    getPortList,
    getEntityPDF,
    upgradeAccount,
    getUserDetails,
};

export default GlobalApi;
